import { apiRequest } from '../Api/ApiRequest';
import { listServices } from './client';

export function api_getAccountServiceGroups() {
  return apiRequest({
    url: '/services',
    method: 'get',
    headers: {
      Authorization: `bearer ${localStorage.getItem('hso-api-token')}`,
    },
  }).then(
    (resp) => resp,
  ).catch(
    (error) => error,
  );
}
export function api_getAccountServices() {
  return listServices();
}
export function api_getServiceGroups() {
  return apiRequest({
    url: '/services/groups',
    method: 'get',
    headers: {
      Authorization: `bearer ${localStorage.getItem('hso-api-token')}`,
    },
  }).then(
    (resp) => resp,
  ).catch(
    (error) => error,
  );
}
